module.exports = __webpack_public_path__ + "static/media/blog-35-img1.f84576eb.webp";